import React, { forwardRef } from 'react';
import PDFPage from '../PDFPage';
import logo from 'assets/share.png';
import styles from '../PDFReportPreview.module.css';

type PacingPageProps = {
    spotAddress: string;
    dateTime: string;
    chartCanvas: HTMLCanvasElement | null;
};

const PacingPage = forwardRef<HTMLDivElement, PacingPageProps>(function PacingPage(
    { spotAddress, dateTime, chartCanvas },
    ref
) {
    return (
        <PDFPage ref={ref} spotAddress={spotAddress} dateTime={dateTime} title="Current Month Pacing">
            {chartCanvas ? (
                <div className={styles.contentContainer}>
                    <img
                        src={chartCanvas.toDataURL('image/png')}
                        alt="Current Month Pacing"
                        className={styles.capturedChart}
                    />
                </div>
            ) : (
                <div className={styles.noDataMessage}>
                    <p>No data available for this chart</p>
                </div>
            )}

            <div className={styles.footerBanner}>
                <img src={logo} alt="AirGarage" className={styles.footerLogo} />
                <p className={styles.footerText}>Do you want to see more details?</p>
                <span className={styles.footerLink}>
                    Go to www.dashboard.airgarage.com
                    <span className={styles.footerArrow}>→</span>
                </span>
            </div>
        </PDFPage>
    );
});

export default PacingPage;
